import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import DiscountBanner from "./components/DiscountBanner";
import Hero from "./components/Hero";
import Steps from "./components/steps";
import Services from "./components/Services";
import Prices from "./components/Prices";
import FAQ from "./components/FAQ";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import GallerySlider from "./components/GallerySlider"
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Imprint from "./pages/Imprint";
import Terms from "./pages/Terms";
import CookieBanner from "./components/CookieBanner";
import MobileCallBar from "./components/MobileCallBar";

export default function App() {
  return (
    <main className="min-h-screen bg-gradient-to-b from-white to-slate-50 text-slate-900">
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <DiscountBanner />
              <Hero />
              <Steps />
              <Services />
              
              <Prices />
              <FAQ />
              <ContactForm />
              <GallerySlider/>
            </>
          }
        />
        <Route path="/datenschutz" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/impressum" element={<Imprint />} />
        <Route path="/agb" element={<Terms />} />
      </Routes>
      <Footer />
      <MobileCallBar />
      <CookieBanner />
    </main>
  );
}
